import { withI18n } from 'react-i18next';
import GlobalDeliverAddressChange from './GlobalDeliverAddressChange';

export const pureComponent = GlobalDeliverAddressChange;
export default withI18n()(GlobalDeliverAddressChange);
